<script setup>
import { useLocalePath } from '#imports'
import { useComingSoonMessage } from '@/components/home/utils/message'

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  name: {
    type: String,
    default: '',
  },
  href: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  className: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  showArrow: {
    type: Boolean,
    default: true,
  },
  icon: {
    type: [Object, String],
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
  tag: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['handleClick'])
const route = useRoute()
const localePath = useLocalePath()
const isActive = computed(() => props.name && route.name.includes(props.name))
const showComingSoonMessage = useComingSoonMessage()
const isDropdownVisible = ref(false)

function handleClick() {
  emit('handleClick')
}
</script>

<template>
  <n-dropdown
    v-model:show="isDropdownVisible"
    :options="options"
    class="!bg-pageSecondary"
    :show-arrow="showArrow"
    :class="$i18n.locale === 'ar' ? 'ltr' : ''"
  >
    <NuxtLink
      class="inline-flex items-center h-10 px-4 text-sm rounded-full cursor-pointer text-textPrimary hover:bg-btnSecondary"
      :class="[className, { '!bg-btnSecondary': isActive }, tag ? 'relative' : '', isDropdownVisible ? 'bg-pageSecondary rounded-full' : '']"
      :to="props.isOpen ? localePath(href) : ''"
      @click="!props.isOpen && showComingSoonMessage()"
    >
      <component :is="icon" v-if="icon" class="w-6 h-6" @click="handleClick()" />
      <slot v-else name="label">
        {{ label }}
        <span v-if="tag" class="absolute -top-2 -right-2 text-textPrimary  inline-flex items-center bg-themeNormal rounded text-xs h-[16px] px-1.5">HOT</span>
      </slot>
    </NuxtLink>
  </n-dropdown>
</template>
